module.exports = __webpack_public_path__ + "img/politcall.e4ec9cba.jpg";